<template>
      <router-view></router-view>
</template>

<script>
export default {
    name: 'Grade',
    components: {
    },
    created() {
    },
    mounted() {
    },
    updated() {
    },
    data(){
        return {
        }
    },
    methods: {
    }
}
</script>